import React from "react";
import { connect } from "react-redux";
import NotFound from "../../routes/errors/NotFound";
import MissionAdmin from "./mission-admin";
import MissionsRequester from "./missions-requester";
import MissionV2 from './mission-v2';
import { allowAccessToMissionRequestAdmin } from "../../enums";

const Missions = (props) => {
  const { user } = props.auth.user;
  const profile = user.profile;
  if (allowAccessToMissionRequestAdmin.includes(profile)) {
    return <MissionAdmin {...props} />;
  } else if (["Solicitante"].includes(profile)) {
    return <MissionV2 {...props} />;
  } else {
    return (
      <NotFound
        code={403}
        message="Desculpe, você não possuí acesso à essa página."
        {...props}
      />
    );
  }
  // switch (profile) {
  //   case "Administração":
  //     return <MissionAdmin {...props} />;
  //   case "Solicitante":
  //     return <MissionV2 {...props} />;
  //   default:

  // }
};

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Missions);



// WEBPACK FOOTER //
// ./src/routes/missions/Missions.js